module.exports = __webpack_public_path__ + "static/media/CheckMark.7d294e03.svg";